import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  ExternalLinkComponent,
  getColumnKey,
  ImageThumbnailComponent,
  ImageThumbnailUnsupportedComponent,
  NoDataComponent,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { AdminBrandCollectionItem } from '../../models/admin-brand-collection-item';
import { AdminBrandCollectionFilter } from '../../models/admin-brand-collection-filter';
import { isNotNil } from '@web/utils';
import { AdminBrandStatusPipe } from '../../pipes/admin-brand-status.pipe';

@Component({
  selector: 'app-admin-brand-list-custom-cell-template',
  imports: [
    AdminBrandStatusPipe,
    CommonModule,
    ExternalLinkComponent,
    ImageThumbnailComponent,
    ImageThumbnailUnsupportedComponent,
    NgOptimizedImage,
    NoDataComponent,
    TableBodyNoReferenceCellComponent,
  ],
  templateUrl: './admin-brand-list-custom-cell-template.component.html',
  styleUrl: './admin-brand-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBrandListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<AdminBrandCollectionItem, AdminBrandCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<AdminBrandCollectionItem>();

  protected readonly getColumnKey = getColumnKey<AdminBrandCollectionItem>;
  protected readonly isNotNil = isNotNil;
}
